// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1apYL","head":"ProcedureTableInfo_head__zKVds"};